import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { ToastProvider } from "@rentos/ui";
import { ThemeProvider } from "../app/_lib/theme";
import { Navbar } from "../app/_components/navbar";
import { Footer } from "../app/_components/footer";
import { LoadingScreen } from "../app/_components/loading-screen";
import { CookieConsent } from "../app/_components/cookie-consent";

// Page imports
import LandingPage from "../app/page";
import AboutPage from "../app/about/page";
import BlogPage from "../app/blog/page";
import BlogPostPage from "../app/blog/[slug]/page";
import ContactPage from "../app/contact/page";
import FeaturesPage from "../app/features/page";
import PricingPage from "../app/pricing/page";
import LegalPage from "../app/legal/page";

/** Old deep links like /legal/privacy-policy now open the tabbed /legal page. */
function LegalSlugRedirect() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={`/legal?tab=${slug ?? ""}`} replace />;
}

export default function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <div className="relative min-h-screen">
          {/* Fixed dark base so the (transparent) body is always dark. */}
          <div aria-hidden className="pointer-events-none fixed inset-0 -z-20 bg-background" />
          {/* Teal top glow + grid, anchored to the TOP of the page and fading
              down into the dark — present on every page's hero area. */}
          <div aria-hidden className="page-grid pointer-events-none absolute inset-x-0 top-0 -z-10 h-[900px]" />
          <div aria-hidden className="page-grid-lines pointer-events-none absolute inset-x-0 top-0 -z-10 h-[900px]" />

          <LoadingScreen />
          <Navbar />
          <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/legal" element={<LegalPage />} />
            {/* Back-compat redirects */}
            <Route path="/legal/:slug" element={<LegalSlugRedirect />} />
            <Route path="/faq" element={<Navigate to="/legal?tab=faq" replace />} />
            <Route path="/privacy" element={<Navigate to="/legal?tab=privacy-policy" replace />} />
            <Route path="/terms" element={<Navigate to="/legal?tab=terms-of-service" replace />} />
            <Route path="/cookies" element={<Navigate to="/legal?tab=cookie-policy" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
          <Footer />
        </div>
        <CookieConsent />
      </ToastProvider>
    </ThemeProvider>
  );
}
